import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  forgotPasswordLink: string = '';
  privacyPolicyLink: string = '';
  isAuthenticated: boolean = false;

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private router: Router,
    private authService: AuthService
  ) {}
  ngOnInit(): void {
    this.forgotPasswordLink = environment.afURLSelfService;
    this.privacyPolicyLink =
      environment.afUrlbase + environment.endPoints.privacyPolicy;

    // Simple check without auto-redirect
    this.authService.isAuthenticated().subscribe({
      next: (isAuthenticated) => {
        this.isAuthenticated = isAuthenticated;
        // Don't auto-redirect, let user decide
        if (isAuthenticated) {
          console.log('User is already authenticated');
        }
      },
      error: (error) => {
        console.error('Auth check failed on login:', error);
        this.isAuthenticated = false;
      },
    });
  }

  loginWithOIDC() {
    if (!this.isAuthenticated) {
      this.authService.login();
    }
  }

  continueToProductSelection() {
    this.router.navigate(['/product-selection']);
  }

  logout() {
    this.authService.logout();
    // Refresh the page to ensure complete state reset
    window.location.reload();
  }

  register() {
    window.location.href =
      environment.afoUrlbase + environment.endPoints.register;
  }
}
